export const getAverageReadTime = (numberOfWords: number) => {
  const averageWordsPerMinute = 225
  return Math.ceil(numberOfWords / averageWordsPerMinute)
}
